(function(){
    $(function () {
        // console.log("food.js");

        // 京天神 野口
        this.swiper = new Swiper("#food_01", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_01_next',
                prevEl: '.food_01_prev',
            },
            pagination: {
                el: '.food_01_pagenation',
                type: 'bullets',
                clickable: true,
            },
        })

        // 東山 吉寿
        this.swiper = new Swiper("#food_02", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_02_next',
                prevEl: '.food_02_prev',
            },
            pagination: {
                el: '.food_02_pagenation',
                type: 'bullets',
                clickable: true,
            },
        })

        // 食堂おがわ
        this.swiper = new Swiper("#food_03", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_03_next',
                prevEl: '.food_03_prev',
            },
            pagination: {
                el: '.food_03_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 焼肉KINTAN
        this.swiper = new Swiper("#food_04", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_04_next',
                prevEl: '.food_04_prev',
            },
            pagination: {
                el: '.food_04_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // Vineria h
        this.swiper = new Swiper("#food_05", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_05_next',
                prevEl: '.food_05_prev',
            },
            pagination: {
                el: '.food_05_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 炭焼芹生
        this.swiper = new Swiper("#food_06", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_06_next',
                prevEl: '.food_06_prev',
            },
            pagination: {
                el: '.food_06_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // アフィナージュ
        this.swiper = new Swiper("#food_07", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_07_next',
                prevEl: '.food_07_prev',
            },
            pagination: {
                el: '.food_07_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // HUNTER
        this.swiper = new Swiper("#food_08", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_08_next',
                prevEl: '.food_08_prev',
            },
            pagination: {
                el: '.food_08_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // エルポジョ
        this.swiper = new Swiper("#food_09", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_09_next',
                prevEl: '.food_09_prev',
            },
            pagination: {
                el: '.food_09_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 富小路 やま岸
        this.swiper = new Swiper("#food_10", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_10_next',
                prevEl: '.food_10_prev',
            },
            pagination: {
                el: '.food_10_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 御幸町 田がわ
        this.swiper = new Swiper("#food_11", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_11_next',
                prevEl: '.food_11_prev',
            },
            pagination: {
                el: '.food_11_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // のぐち 継
        this.swiper = new Swiper("#food_12", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_12_next',
                prevEl: '.food_12_prev',
            },
            pagination: {
                el: '.food_12_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // ヴェーナ
        this.swiper = new Swiper("#food_13", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_13_next',
                prevEl: '.food_13_prev',
            },
            pagination: {
                el: '.food_13_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // おでんムロ
        this.swiper = new Swiper("#food_14", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_14_next',
                prevEl: '.food_14_prev',
            },
            pagination: {
                el: '.food_14_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // ラディーチェ
        this.swiper = new Swiper("#food_15", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_15_next',
                prevEl: '.food_15_prev',
            },
            pagination: {
                el: '.food_15_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // Gibier MIYAMA
        this.swiper = new Swiper("#food_16", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_16_next',
                prevEl: '.food_16_prev',
            },
            pagination: {
                el: '.food_16_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // gion245
        this.swiper = new Swiper("#food_17", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_17_next',
                prevEl: '.food_17_prev',
            },
            pagination: {
                el: '.food_17_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 燕来房
        this.swiper = new Swiper("#food_18", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_18_next',
                prevEl: '.food_18_prev',
            },
            pagination: {
                el: '.food_18_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 貴匠桜
        this.swiper = new Swiper("#food_19", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_19_next',
                prevEl: '.food_19_prev',
            },
            pagination: {
                el: '.food_19_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // CBC
        this.swiper = new Swiper("#food_20", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_20_next',
                prevEl: '.food_20_prev',
            },
            pagination: {
                el: '.food_20_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // Nitta Bakery
        this.swiper = new Swiper("#food_21", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_21_next',
                prevEl: '.food_21_prev',
            },
            pagination: {
                el: '.food_21_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // 雑魚や
        this.swiper = new Swiper("#food_22", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_22_next',
                prevEl: '.food_22_prev',
            },
            pagination: {
                el: '.food_22_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // CBC 2週目
        this.swiper = new Swiper("#food_23", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            loop: false,
            // loop: true,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_23_next',
                prevEl: '.food_23_prev',
            },
            pagination: {
                el: '.food_23_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

        // ニッタベーカリー 2週目
        this.swiper = new Swiper("#food_24", {
            centeredSlides: true,
            spaceBetween: 15,
            slidesPerView: 1.17,
            // loop: true,
            loop: false,
            breakpoints: {
                812: {
                    slidesPerView: 1,
                },
            },
            navigation: {
                nextEl: '.food_24_next',
                prevEl: '.food_24_prev',
            },
            pagination: {
                el: '.food_24_pagenation',
                type: 'bullets',
                clickable: true,
            }
        })

    });
})();
